var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-container",
        [
          _c(
            "b-card-group",
            { attrs: { columns: "" } },
            [
              _c(
                "b-card",
                {
                  staticClass: "mb-2 min-card-size",
                  attrs: { title: "Payments" },
                },
                [
                  _c("hr"),
                  _vm._v(" "),
                  _vm.getVendor.id && !_vm.loading && _vm.isConnected
                    ? _c(
                        "div",
                        [
                          !_vm.getVendor.stripe_id
                            ? _c("StripeConnectButton")
                            : _c("div", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "stripe-link",
                                    attrs: {
                                      target: "_blank",
                                      href: `https://dashboard.stripe.com/${_vm.getVendor.stripe_id}/dashboard`,
                                    },
                                  },
                                  [_vm._v("View Stripe Data")]
                                ),
                              ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getVendor.stripe_id
                    ? _c("div", { staticClass: "stripe-terimanls" }, [
                        _c("h4", { staticClass: "card-title" }, [
                          _vm._v("Terminals"),
                        ]),
                        _vm._v(" "),
                        _vm.getVendor.id && !_vm.loading && _vm.isConnected
                          ? _c("div", [
                              !_vm.getVendor.stripe_location_id
                                ? _c(
                                    "div",
                                    [
                                      _vm.isLoading
                                        ? _c("div", [_c("spinner-loader")], 1)
                                        : _c(
                                            "b-btn",
                                            {
                                              on: {
                                                click:
                                                  _vm.initializeTerminalIntegration,
                                              },
                                            },
                                            [_vm._v("Integrate Readers")]
                                          ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "terminal-status" },
                                        [
                                          _c("b", [_vm._v("Terminal Status:")]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.connectionMessage)
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getAvailableReaders &&
                                      _vm.getAvailableReaders.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "readers-selection",
                                            },
                                            [
                                              _c("h5", [
                                                _vm._v("Readers available:"),
                                              ]),
                                              _vm._v(" "),
                                              _vm._l(
                                                _vm.getAvailableReaders,
                                                function (reader) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: reader.id,
                                                      staticClass:
                                                        "readers-list-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "reader-data",
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("label:"),
                                                          ]),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                reader.label
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "reader-data",
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v("status:"),
                                                          ]),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                reader.status
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-btn",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.connectingReader,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.toggleReaderConnection(
                                                                reader
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.readerButtonText(
                                                                reader.id
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "b-btn",
                                        {
                                          attrs: {
                                            disabled: _vm.connectingReader,
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.registeringReader = true
                                            },
                                          },
                                        },
                                        [_vm._v("Register New Reader")]
                                      ),
                                      _vm._v(" "),
                                      _vm.registeringReader
                                        ? _c(
                                            "div",
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Enter the key sequence "
                                                ),
                                                _c("br"),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("h4", [_vm._v("0 7 1 3 9")]),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                  on the terminal to display your registration code.\n                "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("br"),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c("b-input", {
                                                attrs: {
                                                  placeholder: "Reader Label",
                                                },
                                                model: {
                                                  value: _vm.readerLabel,
                                                  callback: function ($$v) {
                                                    _vm.readerLabel = $$v
                                                  },
                                                  expression: "readerLabel",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("b-input", {
                                                attrs: {
                                                  placeholder:
                                                    "Registration Code",
                                                },
                                                model: {
                                                  value: _vm.registrationCode,
                                                  callback: function ($$v) {
                                                    _vm.registrationCode = $$v
                                                  },
                                                  expression:
                                                    "registrationCode",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("br"),
                                              _vm._v(" "),
                                              _c(
                                                "b-button",
                                                {
                                                  on: {
                                                    click: _vm.registerReader,
                                                  },
                                                },
                                                [_vm._v(" Register ")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.webHookRegistered
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "register-web-hook mt-3 pt-3",
                                            },
                                            [
                                              _c(
                                                "b-btn",
                                                {
                                                  on: {
                                                    click:
                                                      _vm.registerWebHookEndpoint,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Register WebHook Endpoint"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                            ])
                          : _c(
                              "div",
                              [
                                _c("div", {
                                  staticClass: "card-loading-blank",
                                }),
                                _vm._v(" "),
                                _c("spinner-loader"),
                              ],
                              1
                            ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }